import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const check = () => {
      const first = document.getElementById('first-cta');
      if (!first) return;
      setVisible(first.getBoundingClientRect().bottom < 0);
    };
    check();
    window.addEventListener('scroll', check, {
      passive: true
    });
    window.addEventListener('resize', check);
    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, []);
  return <div className="pointer-events-none fixed inset-x-0 bottom-0 z-40 sm:bottom-5 sm:flex sm:justify-center" data-id="element-14" data-mp="bqsr5putb26c">
      <AnimatePresence data-id="element-15" data-mp="196ookp89zr0r">
        {visible && <motion.div initial={{
        y: '120%'
      }} animate={{
        y: 0
      }} exit={{
        y: '120%'
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto border-t border-white/10 bg-navy-950/95 px-3 pb-[calc(env(safe-area-inset-bottom)+12px)] pt-3 backdrop-blur sm:w-[30rem] sm:rounded-3xl sm:border sm:p-3" data-id="element-16" data-mp="197hmr1t6587a">
            <div className="flex items-center gap-3" data-id="element-17" data-mp="21cdstgmo64sm">
              <div className="hidden shrink-0 text-white min-[400px]:block" data-id="element-18" data-mp="26b7a7k52ufy2">
                <p className="text-[11px] font-semibold uppercase leading-none text-white/60 line-through" data-id="element-19" data-mp="1reg8h47xks5a">$237</p>
                <p className="font-display text-2xl font-black leading-none text-cta" data-id="element-20" data-mp="1we2k598420bz">$27</p>
              </div>
              <CtaButton label="Get the Roadmap" compact shake data-id="element-21" data-mp="1iejp9i4b8lhm" />
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}